/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { departamentoActivosGet } from '../fn/departament/departamento-activos-get';
import { DepartamentoActivosGet$Params } from '../fn/departament/departamento-activos-get';
import { departamentoGet } from '../fn/departament/departamento-get';
import { DepartamentoGet$Params } from '../fn/departament/departamento-get';
import { departamentoIdDepartamentGet } from '../fn/departament/departamento-id-departament-get';
import { DepartamentoIdDepartamentGet$Params } from '../fn/departament/departamento-id-departament-get';
import { departamentoPaisIdCountryGet } from '../fn/departament/departamento-pais-id-country-get';
import { DepartamentoPaisIdCountryGet$Params } from '../fn/departament/departamento-pais-id-country-get';

@Injectable({ providedIn: 'root' })
export class DepartamentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `departamentoGet()` */
  static readonly DepartamentoGetPath = '/departamento';

  /**
   * getAll.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `departamentoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoGet$Response(params?: DepartamentoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return departamentoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAll.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `departamentoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoGet(params?: DepartamentoGet$Params, context?: HttpContext): Observable<any> {
    return this.departamentoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `departamentoActivosGet()` */
  static readonly DepartamentoActivosGetPath = '/departamento/activos';

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `departamentoActivosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoActivosGet$Response(params?: DepartamentoActivosGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return departamentoActivosGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `departamentoActivosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoActivosGet(params?: DepartamentoActivosGet$Params, context?: HttpContext): Observable<any> {
    return this.departamentoActivosGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `departamentoIdDepartamentGet()` */
  static readonly DepartamentoIdDepartamentGetPath = '/departamento/{idDepartament}';

  /**
   * getById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `departamentoIdDepartamentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoIdDepartamentGet$Response(params: DepartamentoIdDepartamentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return departamentoIdDepartamentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `departamentoIdDepartamentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoIdDepartamentGet(params: DepartamentoIdDepartamentGet$Params, context?: HttpContext): Observable<any> {
    return this.departamentoIdDepartamentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `departamentoPaisIdCountryGet()` */
  static readonly DepartamentoPaisIdCountryGetPath = '/departamento/pais/{idCountry}';

  /**
   * getByContry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `departamentoPaisIdCountryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoPaisIdCountryGet$Response(params: DepartamentoPaisIdCountryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return departamentoPaisIdCountryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByContry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `departamentoPaisIdCountryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  departamentoPaisIdCountryGet(params: DepartamentoPaisIdCountryGet$Params, context?: HttpContext): Observable<any> {
    return this.departamentoPaisIdCountryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
